<template>
    <div class="tw-flex tw-items-center tw-justify-center tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full lg:tw-mx-auto">
            <div class="tw-container">
                <h2 class="tw-text-center tw-pb-5 lg:tw-pb-5">Bedankt voor je aanmelding</h2>
                <p class="tw-text-black tw-font-medium">
                    Je exclusieve Black Friday-aanbieding in preview<br>
                    wordt u toegestuurd op <span>24-11-2014</span>
                </p>

                <p class="tw-pt-10">Geniet ondertussen</p>
                <div class="code-big">
                    -20%*
                </div>

                <p class="tw-pb-2">
                    nu met de promocode:
                </p>

                <div class="code lg:tw-pt-2 lg:tw-px-4 lg:tw-mx-auto tw-mb-8 lg:tw-mb-10">
                    <p class="tw-text-center tw-font-medium tw-uppercase">w e l c o m e</p>
                </div>

                <div class="steps">
                    <h2>Om hiervan te genieten</h2>
                    <div class="tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-grid-cols-3 lg:tw-gap-6">
                        <div>
                            <span class="number">1</span>
                            <p>Maak een account aan online of meld je aan</p>
                        </div>
                        <div>
                            <span class="number">2</span>
                            <p>Voer de code <span>WELCOME</span> in je winkelmandje in</p>
                        </div>
                        <div>
                            <span class="number">3</span>
                            <p>De korting zal automatisch verrekend worden</p>
                        </div>
                    </div>
                </div>
                <a href="https://bnl.clarins.com/nl/inloggen?utm_medium=affiliate&utm_source=kwanko&utm_campaign=af_bnl-nl_clarins_e-commerce_cv_ld_prp_all_all_1124_black-friday-teasing_na" target="_blank" class="tw-block tw-pt-8 tw-mx-auto" style="max-width: 500px">
                    <button class="btn-cta">Ik profiteer ervan</button>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>
<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

.form-success {
    @apply tw-pb-10;

    @screen lg {
        @apply tw-flex tw-flex-col tw-items-center tw-justify-center tw-pb-0;
    }
    h2 {
        font-family: 'Clarins';
        color: $main_color;
        font-size: 22px;

        @screen lg {
            font-size: 26px;
        }
    }
    h3 {
        font-weight: 500;

        span{
            color: $main_color;
            font-weight: 700;
        }
    }
    .code {
        background-color: $light;
        border: dashed 2px $transparent;
        width: fit-content;
        @apply tw-mx-auto tw-px-4 tw-py-2;

        p {
            color: $main_color;
            font-size: 28px;
        }
    }

    p {
        @apply tw-text-sm;
        font-weight: normal;

        span {
            color: $main_color;
        }
    }

    .code-big {
        font-family: 'Clarins';
        color: $main_color;

        @screen lg {
            font-size: 70px;
        }
    }

    span.number {
        font-family: 'Clarins';
        color: $main_color;
        font-size: 40px;

        @screen lg {
            font-size: 40px;
        }
    }
}

</style >
